export default {
  start: 'Start',
  end: 'Ende',
  vacation: {
    title: 'Urlaub anfragen',
    text: 'Bitte die geplanten Abwesenheitstage auswählen:',
    vacation_requested: 'Urlaubsanfrage übermittelt!',
  },
  holidays: {
    title: 'Feiertag hinzufügen',
    name: 'Beschreibung',
    delete: 'Möchten Sie diesen Feiertag aus dem System löschen?',
  },
  manager_assigned: 'Rayon erfolgreich angelegt',
  edit_route: 'Rayon erfolgreich geändert',
  success_created: 'Mitarbeiter erfolgreich angelegt',
  confirm_leave_request: 'Wollen Sie die Abwesenheit freigeben?',
  reject_leave_reject: 'Wollen Sie die Abwesenheit ablehnen?',
  request_confirmed: 'Die Anfrage wurde erfolgreich freigegeben!',
  request_rejected: 'Die Urlaubsanfrage wurde abgelehnt!',
  tell_reject_leave: 'Bitte einen Ablehnungsgrund eintragen:',
  select_employee: 'Mitarbeiter und Zeitperiode auswählen',
  days: 'Tage',
  for: 'Für',
  from: 'von',
  to: 'bis',
  approved: 'Freigegeben',
  mileage_planned: 'Die dokumentierte Plandistanz wurde überschritten',
  mileage_planned_text:
    'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
  planned: 'geplant',
  actual: 'IST',
  delete_route_text: 'Sind Sie sich sicher, dass Sie den Rayon löschen wollen?',
  not_working_day: 'Als arbeitsfreien Tag markieren',
  start_work_log: 'Neue Tätigkeit dokumentieren',
  end_work_log: 'Tätigkeit beenden',
  edit_work_log: 'Tätigkeit editieren',
  work_log_details: 'Tätigkeitsdetails',
  pause_start: 'Pause Start',
  pause_end: 'Pause Ende',
  work_end: 'Ende',
  choose_type: 'Tätigkeitsart wählen',
  route: 'Rayon',
  address: 'Adresse',
  choose_route: 'Rayon eingeben',
  custom: 'Benutzerdefiniert',
  km_start: 'Privatkilometer',
  start_date: 'Startdatum',
  end_date: 'Enddatum',
  days_error: 'Das Startdatum darf nicht größer sein als das Enddatum',
  start_date_placeholder: 'Start Datum eingeben',
  pause_start_placeholder: 'Pause Start eingeben',
  pause_end_placeholder: 'Pause Ende eingeben',
  work_end_placeholder: 'Ende eingeben',
  no_end_date: 'fortlaufend',
  time: 'Uhrzeit',
  worklog: 'Tätigkeitsbeschreibung',
  worklog_placeholder: 'Tätigkeitsbeschreibung eingeben',
  kilometer_start: 'Kilometerstand Start',
  kilometer_start_placeholder: 'Start Kilometer eingeben',
  kilometer_end: 'KM End',
  kilometer_end_placeholder: 'Endkilometer eingeben',
  add_route: 'Rayon hinzufügen',
  add_address: 'Adresse hinzufügen',
  licence_plate: 'Kennzeichen',
  licence_plate_placeholder: 'Kennzeichen eingeben',
  amount_km: 'Dokumentierte Kilometer',
  mileage_exceeded: 'Abweichung dokumentieren',
  mileage_exceeded_text: 'Bitte tragen Sie ein Abweichungsgrund ein:',
  privately_driven_km: ' Privatkilometer',
  privately_driven_km_placeholder: 'Privatkilometer eingeben',
  travel_mileage_exceeded: 'Abweichungsgrund',
  documented_at: 'Dokumentiert am {date}',

  delete_worklog: {
    do_you_want_to_delete: 'Diese Tätigkeit stornieren?',
    info: '{name} - vom {date}',
    give_reason: 'Bitte geben Sie einen Stornogrund an',
    deleted: 'Tätigkeit erfolgreich storniert',
  },

  work_times_type: {
    normal: {
      title: 'normaler Dienstplan',
      text: 'Wählen Sie die Arbeitstage individuell fest',
    },
    rolling: {
      title: 'rollierender Dienstplan',
      text: '4 Tage Arbeit, 2 Tage frei',
    },
  },

  delete_km_log_text:
    'Sind Sie sich sicher, dass Sie den Kilometerstand aus dem System löschen wollen?',
}
